import Menu from 'Models/Menu';

export default [
  Menu.setHomePage,
  Menu.checkUpdate,
];
